
import 'components/tags.tag'
import './new-categories-list-modal.tag'
import 'pages/settings/geotargeting/geotargeting-list-modal.tag'
riot.tag2('news-edit', '  <loader if="{loader}"></loader>\n  <virtual hide="{loader}">\n    <div class="btn-group"><a class="btn btn-default" href="#news"><i class="fa fa-chevron-left"></i></a>\n      <button class="btn {item._edit_ ? &quot;btn-success&quot; : &quot;btn-default&quot;}" if="{isNew ? checkPermission(&quot;news&quot;, &quot;0100&quot;) : checkPermission(&quot;news&quot;, &quot;0010&quot;)}" onclick="{submit}" type="button"><i class="fa fa-floppy-o"></i> Сохранить</button>\n      <button class="btn btn-default" if="{!isNew}" onclick="{reload}" title="Обновить" type="button"><i class="fa fa-refresh"></i></button>\n    </div>\n    <div class="h4"> {isNew ? item.name || \'Добавление новости\' : item.name || \'Редактирование новости\'}</div>\n    <ul class="nav nav-tabs m-b-2">\n      <li class="active"><a data-toggle="tab" href="#news-edit-home">Основная информация</a></li>\n      <li><a data-toggle="tab" href="#news-edit-images">Галерея</a></li>\n      <li if="{item.customFields &amp;&amp; item.customFields.length}"><a data-toggle="tab" href="#news-edit-fields">Доп. информация</a></li>\n      <li><a data-toggle="tab" href="#news-edit-subscribers">Группы подписчиков</a></li>\n      <li><a data-toggle="tab" href="#news-edit-seo">SEO</a></li>\n    </ul>\n    <form action="" onchange="{change}" onkeyup="{change}" method="POST">\n      <div class="tab-content">\n        <div class="tab-pane fade in active" id="news-edit-home">\n          <div class="row">\n            <div class="col-md-2">\n              <div class="form-group">\n                <div class="well well-sm">\n                  <image-select name="imageFile" section="newsimg" alt="0" size="256" value="{item.imageFile}"></image-select>\n                </div>\n              </div>\n            </div>\n            <div class="col-md-10">\n              <div class="row">\n                <div class="col-md-8">\n                  <div class="form-group {has-error: error.name}">\n                    <label class="control-label">Заголовок</label>\n                    <input class="form-control" name="name" type="text" value="{item.name}">\n                    <div class="help-block">{error.name}</div>\n                  </div>\n                </div>\n                <div class="col-md-4">\n                  <div class="form-group {has-error: error.url}">\n                    <label class="control-label">URL</label>\n                    <input class="form-control" name="url" type="text" value="{item.url}">\n                    <div class="help-block">{error.url}</div>\n                  </div>\n                </div>\n              </div>\n              <div class="row">\n                <div class="col-md-2">\n                  <div class="form-group">\n                    <label class="control-label">Дата</label>\n                    <datetime-picker class="form-control" name="newsDate" format="DD.MM.YYYY" value="{item.newsDateDisplay}" title="Дата публикации"></datetime-picker>\n                  </div>\n                </div>\n                <div class="col-md-4">\n                  <div class="form-group">\n                    <label class="control-label">Категория</label>\n                    <div class="input-group">\n                      <input class="form-control" name="nameCategory" value="{item.nameCategory}" readonly>\n                      <div class="input-group-btn">\n                        <div class="btn btn-default" onclick="{changeCategory}"><i class="fa fa-list text-primary"></i></div>\n                      </div>\n                    </div>\n                  </div>\n                </div>\n                <div class="col-md-6">\n                  <div class="form-group">\n                    <label class="control-label">Регион</label>\n                    <div class="input-group">\n                      <tags class="form-control" name="geoCity" value="{item.geoCity}"></tags><span class="input-group-addon" onclick="{addCity}"><i class="fa fa-plus"></i></span>\n                    </div>\n                  </div>\n                </div>\n              </div>\n              <div class="row">\n                <div class="col-md-2">\n                  <div class="form-group">\n                    <div class="checkbox-inline">\n                      <label>\n                        <input type="checkbox" name="isActive" __checked="{item.isActive}">Отображать на сайте\n                      </label>\n                    </div>\n                  </div>\n                </div>\n                <div class="col-md-4">\n                  <div class="form-group">\n                    <div class="checkbox-inline">\n                      <label>\n                        <input type="checkbox" name="isDatePublic" __checked="{item.isDatePublic}">Отложенная публикация\n                      </label>\n                    </div>\n                    <div class="form-group" if="{item.isDatePublic}">\n                      <datetime-picker class="form-control" name="publicationDate" format="DD.MM.YYYY" value="{item.publicationDateDisplay}"></datetime-picker>\n                    </div>\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n          <div class="row">\n            <div class="col-md-12">\n              <div class="form-group">\n                <label class="control-label">Анонс ({countAnonse} из 500 знаков)</label>\n                <textarea class="form-control text-anonse" name="shortTxt" value="{item.shortTxt}" oninput="{changeCountAnonse}"></textarea>\n              </div>\n            </div>\n          </div>\n          <div class="row">\n            <div class="col-md-12">\n              <div class="form-group">\n                <label class="control-label">Подробный текст</label>\n                <ckeditor name="text" value="{item.text}"></ckeditor>\n              </div>\n            </div>\n          </div>\n        </div>\n        <div class="tab-pane fade" id="news-edit-images">\n          <product-edit-images name="images" value="{item.images}" section="newsimg"></product-edit-images>\n        </div>\n        <div class="tab-pane fade" id="news-edit-fields" if="{item.customFields &amp;&amp; item.customFields.length}">\n          <add-fields-edit-block name="customFields" value="{item.customFields}"></add-fields-edit-block>\n        </div>\n        <div class="tab-pane fade" id="news-edit-subscribers">\n          <catalog-static name="subscribersGroups" rows="{item.subscribersGroups}" add="{addSubscribersGroups}" cols="{subscribersGroupsCols}" remove="true">\n            <yield to="body">\n              <datatable-cell name="id">{row.id}</datatable-cell>\n              <datatable-cell name="name">{row.name}</datatable-cell>\n            </yield>\n          </catalog-static>\n        </div>\n        <div class="tab-pane fade" id="news-edit-seo">\n          <form action="" onchange="{change}" onkeyup="{change}" method="POST">\n            <div class="row">\n              <div class="col-md-12">\n                <div class="form-group">\n                  <label class="control-label"> Заголовок</label>\n                  <input class="form-control" name="seotitle" type="text" onfocus="{seoTag.focus}" value="{item.seotitle}">\n                </div>\n                <div class="form-group">\n                  <label class="control-label"> Ключевые слова</label>\n                  <input class="form-control" name="keywords" type="text" onfocus="{seoTag.focus}" value="{item.keywords}">\n                </div>\n                <div class="form-group">\n                  <label class="control-label"> Описание</label>\n                  <textarea class="form-control" rows="5" name="description" onfocus="{seoTag.focus}" style="min-width: 100%; max-width: 100%;" value="{item.description}"></textarea>\n                </div>\n              </div>\n            </div>\n          </form>\n        </div>\n      </div>\n    </form>\n  </virtual>\n', 'textarea.text-anonse { min-height: 100px; }', '', function(opts) {
'use strict';

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var self = this;

self.isNew = false;

self.item = {};
self.orders = [];

self.mixin('validation');
self.mixin('permissions');
self.mixin('change');

self.countAnonse = 0;

self.rules = {
    name: 'empty'
};

self.afterChange = function (e) {
    var name = e.target.name;
    delete self.error[name];
    self.error = (0, _extends3.default)({}, self.error, self.validation.validate(self.item, self.rules, name));
};

self.submit = function (e) {
    var params = self.item;

    self.error = self.validation.validate(self.item, self.rules);

    if (!self.error) {
        API.request({
            object: 'News',
            method: 'Save',
            data: params,
            success: function success(response) {
                popups.create({ title: 'Успех!', text: 'Изменения сохранены!', style: 'popup-success' });
                self.item = response;
                self.update();
                if (self.isNew) riot.route('/news/' + self.item.id);
                observable.trigger('news-reload');
            }
        });
    }
};

self.changeCategory = function () {
    modals.create('new-categories-list-modal', {
        type: 'modal-primary',
        submit: function submit() {
            var items = this.tags.catalog.tags.datatable.getSelectedRows();

            if (items.length > 0) {
                self.item.idCategory = items[0].id;
                self.item.nameCategory = items[0].title;
                self.update();
                this.modalHide();
            }
        }
    });
};

self.subscribersGroupsCols = [{ name: 'id', value: '#' }, { name: 'name', value: 'Наименование' }];

self.changeCountAnonse = function (e) {
    var value = e === undefined ? self.item.shortTxt : e.target.value;
    value = value || '';
    self.countAnonse = value.length;
};

self.addCity = function () {
    modals.create('geotargeting-list-modal', {
        type: 'modal-primary',
        submit: function submit() {
            self.item.geoCity = self.item.geoCity || [];
            var items = this.tags.geotargeting.tags.datatable.getSelectedRows();
            var ids = self.item.geoCity.map(function (item) {
                return item.id;
            });

            items.forEach(function (item) {
                if (ids.indexOf(item.id) === -1) self.item.geoCity.push(item);
            });
            self.update();
            this.modalHide();
        }
    });
};

self.addSubscribersGroups = function () {
    modals.create('persons-category-select-modal', {
        type: 'modal-primary',
        submit: function submit() {
            self.item.subscribersGroups = self.item.subscribersGroups || [];
            var items = this.tags.catalog.tags.datatable.getSelectedRows();

            var ids = self.item.subscribersGroups.map(function (item) {
                return item.id;
            });

            items.forEach(function (item) {
                if (ids.indexOf(item.id) === -1) {
                    self.item.subscribersGroups.push(item);
                }
            });

            self.update();
            this.modalHide();
        }
    });
};

observable.on('news-new', function (item) {
    var category = item.category,
        name = item.name;

    self.error = false;
    self.isNew = true;
    self.item = {
        publicationDate: new Date().toLocaleDateString(),
        publicationDateDisplay: new Date().toLocaleDateString(),
        idCategory: category,
        nameCategory: decodeURI(name)
    };
    self.update();
});

observable.on('news-edit', function (id) {
    var params = { id: id };
    self.error = false;
    self.isNew = false;
    self.loader = true;
    self.item = {};

    API.request({
        object: 'News',
        method: 'Info',
        data: params,
        success: function success(response, xhr) {
            self.item = response;
            self.loader = false;
            self.changeCountAnonse();
            self.update();
        },
        error: function error(response) {
            self.item = {};
            self.loader = false;
            self.update();
        }
    });
});

self.on('update', function () {
    localStorage.setItem('SE_section', 'newsimg');
});

self.reload = function () {
    self.item.id ? observable.trigger('news-edit', self.item.id) : observable.trigger('news-new');
};

self.on('mount', function () {
    riot.route.exec();
});
});


// WEBPACK FOOTER //
// ./pages/news/news-edit.tag